<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/POA/components/Evaluation/Final/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>